import React from "react"
import { Col, Row, Form, Dropdown } from "react-bootstrap"
import { getIn } from "formik"
import FormLabel from "../formLabel"

function FeedbackFormStarRate(props) {
    const {
        textDesc,
        form,
        field,
        rateItem
    } = props

    const errorsMsg = getIn(form.errors, field.name)

    const inputErrorMessage = (touched, errors, inputName) => {
        return errors[inputName] && touched[inputName] ? (
            <span className="InputError">{errorsMsg}</span>
        ) : null
    }

    const valueChange = (value) => {
        form.setFieldValue(field.name, value)
    }

    return (
        <Form.Group>
            <Row>
                <Col xs={"auto"} md={"auto"} className="textforinput marginTop10px MarginBottom15 marginLeftRightAuto">
                    <p>{textDesc}</p>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6} className="marginLeftRightAuto">
                    <div className="d-flex justify-content-center">
                        {rateItem.map((item, key) => (
                            <div key={key} className={"mx-3 rateStart " + (field.value >= item ? "rateStartChecked" : "")} fill="currentColor"
                                onClick={() => {
                                    valueChange(item)
                                    form.setFieldValue(
                                        field.name,
                                        item,
                                        true
                                    )
                                }}>
                                &nbsp;
                            </div>
                        ))}
                    </div>
                    {inputErrorMessage(form.touched, form.errors, field.name)}
                </Col>
            </Row>
        </Form.Group >
    )
}

export default FeedbackFormStarRate
